module.exports = __webpack_public_path__ + "static/media/aplogo.4e74ee6d.png";